import { Pages, routeBuilders, routeUpdaters } from "../routes/routes.state"
import { CurrentPage } from "../../../Shared/Frontend/utils/routes.shared"
import { application, ApplicationState } from "../allIncludedModules"
import { initialRoute } from "widgets-for-react"

export type ProductId = number

export type State = {
  page: CurrentPage<Pages>,
  lastUpdate?: "shopping cart" | "products"
} & ApplicationState

export const initialRootState = (): State => {
  const initialState: State = ({
    ...application.initialState(),
    page: routeBuilders.drupal.make({ slug: "" })
  })

  const updater = initialRoute(application.routeWidgets())
  return updater == undefined ? initialState : updater(initialState)
}

export const stateUpdaters = {
  routes: routeUpdaters
}
